export default __webpack_public_path__ + "static/media/edit_darkgreen.673883b6.svg";